import { AApi } from './AApi';
import type { ApiResult, PaginationBody, PaginationParams } from '../types/api.types';
import type { RightBody, RightInput, RightSubject, TagBody } from '../types/rights.types';

/** The Rights module: `/tags`, `/rights`, for admins. */
export class RightsApi extends AApi {
    public createRight(data: RightInput): Promise<ApiResult<{ right: RightBody }>> {
        return this.Client.post(`${this.VersionPath}/rights`, data);
    }

    public createTag(tag: string): Promise<ApiResult<{ tag: TagBody }>> {
        return this.Client.post(`${this.VersionPath}/tags`, { tag });
    }

    public deleteRight(rightId: number): Promise<ApiResult<undefined>> {
        return this.Client.delete(`${this.VersionPath}/rights/${rightId.toString()}`);
    }

    public deleteTag(tagInx: string): Promise<ApiResult<undefined>> {
        return this.Client.delete(`${this.VersionPath}/tags/${encodeURIComponent(tagInx)}`);
    }

    public getRight(rightId: number): Promise<ApiResult<{ right: RightBody }>> {
        return this.Client.get(`${this.VersionPath}/rights/${rightId.toString()}`);
    }

    public getTag(tagInx: string): Promise<ApiResult<{ tag: TagBody }>> {
        return this.Client.get(`${this.VersionPath}/tags/${encodeURIComponent(tagInx)}`);
    }

    /** With `subject` only the rights of that user or team. */
    public listRights(params?: PaginationParams, subject?: RightSubject): Promise<ApiResult<{ rights: RightBody[]; pagination?: PaginationBody }>> {
        return this.Client.get(`${this.VersionPath}/rights${this.toQuery(params, subject)}`);
    }

    public listTags(params?: PaginationParams): Promise<ApiResult<{ tags: TagBody[]; pagination?: PaginationBody }>> {
        return this.Client.get(`${this.VersionPath}/tags${this.toQuery(params)}`);
    }

    /** Only the level changes; another subject or target is another right. */
    public updateRight(rightId: number, level: number): Promise<ApiResult<{ right: RightBody }>> {
        return this.Client.patch(`${this.VersionPath}/rights/${rightId.toString()}`, { level });
    }

    /** Another spelling stays the same tag, another name becomes a new one taking over every use. */
    public updateTag(tagInx: string, tag: string): Promise<ApiResult<{ tag: TagBody }>> {
        return this.Client.patch(`${this.VersionPath}/tags/${encodeURIComponent(tagInx)}`, { tag });
    }
}
